<template>
  <div class="jump-warp">
  </div>
</template>
<script>
import Vue from "vue";
import { Button } from "vant";
import { Field } from "vant";
import { Picker } from "vant";
import { Popup } from "vant";
import { Checkbox, CheckboxGroup } from "vant";
import { DatetimePicker } from "vant";

Vue.use(DatetimePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Button);
export default {
  name: "online",

  data() {
    return {
      showNature: false,
      
    };
  },
  methods: {
    
  },
};
</script>
<style lang="less" scoped>
.jump-warp {
  background: url("..//assets/supplier/end.jpeg") no-repeat 0 0;
  background-size: 100%;
  position:absolute;
  top: 10;
  left: 0;
  bottom: -100px;
  padding-top: 200%;
  width: 100%;
  height:100%;
  overflow: auto;
  margin-top: -45px;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  z-index:-10;  
  zoom: 1;
}




.van-field__control {
  width: 250px !important;
}

</style>
